import React from 'react';
import PropTypes from 'prop-types';
import {
  CardWrapper,
  Card,
  SuggestedBadge,
  Image,
  Content,
  Title,
  Price,
  Description,
  InfoBox,
  InfoIcon,
  InfoContent,
} from './PromotionCard.styles';
import { ThumbsUpIcon } from './icons';

const PromotionCard = ({ promotion, isSelected, onSelect }) => {
  return (
    <div>
      <CardWrapper>
        {promotion.is_suggested && (
          <SuggestedBadge>Empfohlen</SuggestedBadge>
        )}
        <Card isSelected={isSelected} onClick={() => onSelect(promotion)}>
          <Image>
            {promotion.image_url && (
              <img src={promotion.image_url} alt={promotion.title} />
            )}
          </Image>
          <Content style={{ background: promotion.green_flag ? '#F5FBEE' : undefined }}>
            <Title>{promotion.title}</Title>
            {promotion.subtitle && <Price>{promotion.subtitle}</Price>}
            {promotion.description && (
              <Description
                dangerouslySetInnerHTML={{ __html: promotion.description }}
              />
            )}
          </Content>
        </Card>
      </CardWrapper>

      {isSelected && (
        <InfoBox>
          <InfoIcon>
            <ThumbsUpIcon />
          </InfoIcon>
          <InfoContent>
            <strong>Gute Auswahl – wie geht es jetzt weiter?</strong>
            <br />
            Du hast {promotion.title} angefragt. Nach Einreichung deines Projekts
            melden wir uns bei dir und besprechen die Einzelheiten deiner Promotion
            (z.B. Zeitraum, Inhalt). Erst dann buchst du das Paket.{' '}
            <b>
              Gerne kannst du auch mehrere Pakete anfragen, falls du mehr Infos zu
              verschiedenen Paketen wünschst!
            </b>
          </InfoContent>
        </InfoBox>
      )}
    </div>
  );
};

PromotionCard.propTypes = {
  promotion: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    description: PropTypes.string,
    image_url: PropTypes.string,
    is_suggested: PropTypes.bool,
    green_flag: PropTypes.bool,
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default PromotionCard;
